import React, { useContext, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { Select, MenuItem, FormControl, FormControlLabel, RadioGroup, Radio, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import { useSnackbar } from "notistack";
import ButtonTheme from "../../ThemeButton/ThemeButton";
import ApiService from "../../../functions/apiService";
import MyTable from "../../Schedule/MyTable";
import { getGridStringOperators } from "@mui/x-data-grid";
import { toast } from 'react-toastify';

export default function UpdateConfTable() {
    // const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [modalData, setModalData] = useState([]);
    const {
        register,
        control,
        formState: { errors },
        handleSubmit,
        setError,
        setValue,
        getValues,
        reset,
        watch
    } = useForm({
        defaultValues: {
            Update: 'add',
        },
    });
    let columns = [
        {
            field: 'Var', headerName: 'Var', flex: 1, minWidth: 120,
            filterOperators: getGridStringOperators().filter(
                (operator) => operator.value === "contains"
            ),
        },
        {
            field: 'Value', headerName: 'Value', flex: 1, minWidth: 120,
            filterOperators: getGridStringOperators().filter(
                (operator) => operator.value === "contains"
            ),
        },

    ];
    const onSubmit = (body) => {
        setLoading(true);
        ApiService.post('/updateConfigFile', body).then(({ data }) => {
            setLoading(false);
            console.log('data', data);
            setModalData(data)
            setOpen(true);
            toast.success('Success')
            // enqueueSnackbar('success', { variant: 'success' });
        }).catch(({ data }) => {
            setLoading(false);
            toast.error('Error')
            // enqueueSnackbar('Error', { variant: 'error' });
        });
        console.log('body', body);
    }
    let closeModal = () => {
        setOpen(false);
    }
    return <>
        <Typography fontWeight='700' fontSize="16px">Update _Config Table</Typography>
        <form onSubmit={handleSubmit(onSubmit)}>
            <div>
                <FormControl>
                    <RadioGroup
                        defaultValue={"add"}
                        name="radio-buttons-group"
                        row
                    >

                        <FormControlLabel
                            value="add"
                            {...register("Update")}
                            control={<Radio />}
                            label={
                                <Typography
                                    sx={{
                                        textTransform:
                                            "capitalize",
                                        fontSize: '14px'
                                    }}
                                >
                                    Add missing records
                                </Typography>
                            }
                        />
                        <FormControlLabel
                            value="delete"
                            {...register("Update")}
                            control={<Radio />}
                            label={
                                <Typography
                                    sx={{
                                        textTransform:
                                            "capitalize",
                                        fontSize: '14px'
                                    }}
                                >
                                    Delete deprecated records
                                </Typography>
                            }
                        />
                    </RadioGroup>
                </FormControl>
            </div>

            <div className="col-12 mt-2">
                <ButtonTheme disabled={loading} type='submit' color='primary'>Update Config</ButtonTheme>
            </div>


        </form>
        <Dialog
            sx={{ '& .MuiDialog-paper': { width: '90vw' } }}
            maxWidth='lg'
            open={open}
            onClose={closeModal}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                Variables
            </DialogTitle>
            <DialogContent>
                <MyTable
                    rows={modalData}
                    columns={columns}
                    useTopFilter={false}
                    checkboxSelection={false}
                    hideFooter={true}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={closeModal}>Cancel</Button>
            </DialogActions>
        </Dialog>
    </>
}
